import { includesEnumValue, ModeEnum, toBigWithDefault, type Order } from '@talos/kyoko';

export function showIWouldAnalytics(order: Order): boolean {
  const isIWouldEnabled = includesEnumValue([ModeEnum.Enabled], order.Parameters?.IWouldEnabled ?? '');
  return isIWouldEnabled || toBigWithDefault(order.IWouldFilledQty, 0).gt(0);
}
